import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { useIsAgentChatEnabled } from '~/hooks/useIsAgentChatEnabled'

import { ChatMode, useAgentChat } from './AgentChatContext'
import AgentChatPanel from './AgentChatPanel'
import AgentFloatingButton from './AgentFloatingButton'
import FloatingChatWindow from './FloatingChatWindow'

const AgentChatManager = () => {
  const { isChatOpen, closeChat, openChat, chatMode } = useAgentChat()
  const isAgentChatEnabled = useIsAgentChatEnabled()

  if (!isAgentChatEnabled) {
    return null
  }

  return (
    <ErrorBoundary
      fallback={<></>}
      onError={(error, errorInfo) => {
        // eslint-disable-next-line no-console
        console.error('Agent Chat Error:', error, errorInfo)
      }}
    >
      {isChatOpen && chatMode === ChatMode.RAIL && (
        <AgentChatPanel closeChat={closeChat} />
      )}
      {isChatOpen && chatMode === ChatMode.FLOATING && <FloatingChatWindow />}
      <AgentFloatingButton />
    </ErrorBoundary>
  )
}

export default AgentChatManager
